import {GenericDialog} from "./GenericDialog";

export class InputDialogBase<P, S> extends GenericDialog<P> {
    public onOK() {
        this.closeDialog();
        this.resolve(this.panel.state);
    }
    public setPanelState(state: S, callback? : ()=> any) {
        this.panel.setState(state, callback);
    }
}


// WEBPACK FOOTER //
// ./Client/Dialogs/InputDialogBase.ts